import { Component, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { BsModalService } from 'ngx-bootstrap';
import { CampaignService } from '../../../../../common/services/Campaign.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { EmailService } from '../../../../../common/services/Email.service';
import { IvrgatewayService } from '../../../../../common/services/Ivrgateway.service';
import { QueueService } from '../../../../../common/services/Queue.service';
import { TimeService } from '../../../../../common/services/Time.service';
import { ExportService } from '../../../../../common/services/Export.service';
import { UserService } from '../../../../../common/services/User.service';
import { CampaignType, CampaignTypeArray, DialModeArray } from '../campaign.const';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { Observable } from 'rxjs/Observable';
import { FormFieldType, ModalType } from '../../../../../components/modals/modal-form-template/modal-form.const';
import { CoreTemplateService } from '../../../../../common/services/CoreTemplate.service';
import { Router } from '@angular/router';
import { Reportv2Tab } from '../../reportv2/reportv2.const';

declare var $: any;

@Component({
  selector: 'campaign-list',
  templateUrl: 'list.template.html',
  styleUrls: ['../campaign.css'],
  providers: [
    BsModalService,
    CampaignService,
    EmailService,
    IvrgatewayService,
    QueueService,
    TimeService,
    UserService,
    CoreTemplateService,
  ],
})
export class ListComponent extends BaseListComponent {
  @ViewChild('templateCampaign') templateCampaign: ElementRef;
  @Output('backMode') backMode = new EventEmitter();
  public dataReport: any = {
    isReport: false,
    campaignId: null,
  };
  public pageSize = 10;
  public modelFilter: any = {};
  public tab: any = 'call';
  public listToExport: any = [];
  public exportData: any = [];
  public campaignTypes = [{ id: '', text: 'Loại chiến dịch' }, ...CampaignTypeArray];
  public campaignTypesFilter = [{ id: 'all', text: 'Chọn' }, ...CampaignTypeArray];
  public dialModes = [{ id: '', text: 'Hình thức' }, ...DialModeArray];
  minDate = new Date();

  public selected: any = {};
  public allTemplate: any = [];
  public allEmailAccount: any = [];
  public lstTemplate: any = [];
  public allGateway: any = [];
  public allQueue: any = [];
  public allSchedule: any = [];
  public modelCallOut: any = {};
  public readonly CampaignType = CampaignType;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private campaignService: CampaignService,
    private emailService: EmailService,
    private ivrgatewayService: IvrgatewayService,
    private queueService: QueueService,
    private timeService: TimeService,
    private exportService: ExportService,
    private userService: UserService,
    private coreTemplateService: CoreTemplateService,
    private router: Router
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
    };
    this.is_loading = true;
    Observable.forkJoin([
      this.loadTemplate(),
      this.loadEmailAccount(),
      this.loadIvrGateway(),
      this.loadQueue(),
      this.loadSchedule(),
    ]).subscribe(() => {
      this.loadData(this.modelFilter).then();
    });
  }

  loadTemplate(request: any = {}, sort: any = {}) {
    return this.coreTemplateService.list('all', request).map(res => {
      const templateList = [{ id: '', text: 'Mẫu tin nhắn', type: '' }];
      if (res.status == 200 && !res.error) {
        res.data.data.forEach(e => {
          templateList.push({
            id: e.id,
            text: e.template_name,
            type: e.type,
          });
        });
        this.allTemplate = templateList;
      }
    });
  }

  loadSchedule(request: any = {}, sort: any = {}) {
    request['limit'] = 500;
    request['keyword'] = '';
    return this.timeService.listSchedule(request).map(res => {
      const scheduleList = [{ id: '', text: 'Lịch làm việc' }];
      if (res.status == 200 && !res.error) {
        res.data.data.forEach(e => {
          scheduleList.push({
            id: e.TIME_SCHEDULE_ID,
            text: e.TIME_SCHEDULE_NAME,
          });
        });
        this.allSchedule = scheduleList;
      }
    });
  }

  loadEmailAccount(request: any = {}, sort: any = {}) {
    return this.emailService.listAccount(request).map(res => {
      const emailList = [{ id: '', text: 'Tài khoản email' }];
      if (res.status == 200 && !res.error) {
        res.data.list.forEach(e => {
          emailList.push({
            id: e.ID,
            text: e.ACCOUNT_NAME,
          });
        });
        this.allEmailAccount = emailList;
      }
    });
  }

  loadIvrGateway(request: any = {}, sort: any = {}) {
    return this.ivrgatewayService.list(request).map(res => {
      const allGateway = [{ id: '-1', text: 'Chọn' }];
      if (res.status == 200 && !res.error) {
        res.data.ivrgateways.forEach(e => {
          allGateway.push({
            id: e.ivrgateway_id,
            text: e.line,
          });
        });
        this.allGateway = allGateway;
      }
    });
  }

  loadQueue(request: any = {}, sort: any = {}) {
    return this.queueService.list(request).map(res => {
      const allQueue = [{ id: '', text: 'Hàng đợi' }];
      if (res.status == 200 && res.error == false) {
        res.data.queues.forEach(e => {
          allQueue.push({
            id: e.QUEUE_ID,
            text: e.DESCRIPTION,
          });
        });
        this.allQueue = allQueue;
      }
    });
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.is_loading = true;
    this.listToExport = [];
    const payload = await this.buildBasePayload(request, sort);
    this.campaignService.list(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.listToExport = res.data.listToExport;
          this.data = res.data.list;
          this.data.forEach(e => {
            const type = _.find(this.campaignTypes, { id: e.campaign_type });
            if (type) {
              e.campaignType = type.text;
            } else {
              e.campaignType = '';
            }
            e.time_start = moment(e.time_start).utc(false).format('YYYY-MM-DD HH:mm');
            e.time_end = moment(e.time_end).utc(false).format('YYYY-MM-DD HH:mm');
            e.total_contact_success = parseFloat(e.total_contact.value) - parseFloat(e.total_contact_failed.value) || 0;
          });
          this.initPage(res.data.total);
        } else {
          this.data = [];
        }
      },
      err => {
        this.data = [];
      },
      () => {
        this.is_loading = false;
      }
    );
  }

  openDetailCampaign(campaign_id) {
    this.backMode.emit({
      mode: 'detail',
      id: campaign_id,
    });
  }

  openConfirmDelete(id?: any) {
    if (id) {
      this.delete_ids = [id];
    } else {
      this.delete_ids = this.lstChecked;
    }
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  updateStatus(index, status) {
    if (this.data[index]) {
      this.campaignService.update(this.data[index]._id, { campaign_status: status }).subscribe(res => {
        if (!res.error) {
          this.data[index].campaign_status = status;
          this.throwSuccess('Chuyển trạng thái chiến dịch thành công!');
        } else {
          this.throwError('Chuyển trạng thái chiến dịch không thành công!');
        }
      });
    }
  }

  submitDelete() {
    this.campaignService.deleteMany({ campaign_ids: this.delete_ids }).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.is_loading = true;
        setTimeout(
          function () {
            this.loadData();
            this.throwSuccess('Xóa thành công!');
          }.bind(this),
          3000
        );
      } else {
        this.throwError('Xóa không thành công!');
      }
    });
  }

  copy(payload) {
    delete payload._id;
    payload['name'] = payload['name'] + ' copy';
    this.campaignService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Sao chép thành công!');
          this.openDetailCampaign(res.data._id);
        } else {
          this.throwError(res.message);
        }
      },
      error => this.throwError(error.message)
    );
  }

  saveCampaign(payload) {
    this.campaignService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.closeModal();
          this.openDetailCampaign(res.data._id);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  ///
  async setUpModal(type) {
    this.typeModal = type;
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới chiến dịch' : 'Cập nhật chiến dịch',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên chiến dịch',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'campaign_type',
        label: 'Loại chiến dịch',
        type: FormFieldType.Select2,
        value: this.model.campaign_type,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
        options: {
          data: this.campaignTypes,
          select2Options: {
            placeholder: { id: '', text: 'Loại chiến dịch' },
          },
        },
      },
    ];
    if (this.model.campaign_type === CampaignType.Call) {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'queue_id',
          label: 'Hàng đợi',
          type: FormFieldType.Select2,
          value: this.model.queue_id,
          required: true,
          disabled: false,
          width: 'full',
          order: 2,
          options: {
            data: this.allQueue,
            select2Options: {
              placeholder: { id: '', text: 'Hàng đợi' },
            },
          },
        },
        {
          key: 'dial_mode',
          label: 'Hình thức',
          type: FormFieldType.Select2,
          value: this.model.dial_mode,
          required: true,
          disabled: false,
          width: 'full',
          order: 3,
          options: {
            data: this.dialModes,
            select2Options: {
              placeholder: { id: '', text: 'Hình thức' },
            },
          },
        },
        {
          key: 'callback_url',
          label: 'Callback Url',
          type: FormFieldType.Text,
          value: this.model.callback_url,
          required: false,
          disabled: false,
          width: 'full',
          order: 4,
        },
      ];
    }
    if (this.model.campaign_type === CampaignType.Email) {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'email_account_id',
          label: 'Tài khoản email',
          type: FormFieldType.Select2,
          value: this.model.email_account_id,
          required: true,
          disabled: false,
          width: 'full',
          order: 5,
          options: {
            data: this.allEmailAccount,
            select2Options: {
              placeholder: { id: '', text: 'Tài khoản email' },
            },
          },
        },
      ];
    }
    if (this.model.campaign_type && this.model.campaign_type !== CampaignType.Call) {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'template_id',
          label: 'Mẫu tin nhắn',
          type: FormFieldType.Select2,
          value: this.model.template_id,
          required: true,
          disabled: false,
          width: 'full',
          order: 6,
          options: {
            data: this.lstTemplate,
            select2Options: {
              placeholder: { id: '', text: 'Mẫu tin nhắn' },
            },
          },
        },
      ];
    }
    this.modelDisplay = [
      ...this.modelDisplay,
      {
        key: 'schedule_id',
        label: 'Lịch làm việc',
        type: FormFieldType.Select2,
        value: this.model.schedule_id,
        required: true,
        disabled: false,
        width: 'full',
        order: 7,
        options: {
          data: this.allSchedule,
          select2Options: {
            placeholder: { id: '', text: 'Lịch làm việc' },
          },
        },
      },
      {
        key: 'time_start',
        label: 'Thời gian bắt đầu',
        type: FormFieldType.Datepicker,
        value: this.model.time_start,
        required: true,
        disabled: false,
        width: '1/2',
        order: 8,
        placeholder: 'Thời gian bắt đầu',
        options: {
          placement: 'right',
        },
      },
      {
        key: 'time_end',
        label: 'Thời gian kết thúc',
        type: FormFieldType.Datepicker,
        value: this.model.time_end,
        required: true,
        disabled: false,
        width: '1/2',
        order: 9,
        placeholder: 'Thời gian kết thúc',
        options: {
          placement: 'right',
        },
      },
    ];
  }

  changeDialMode($event) {
    this.model['dial_mode'] = $event.value;
  }

  changeSchedule($event) {
    this.model.schedule_id = $event.value;
  }

  async openAddTemplate() {
    this.model = {};
    this.modelCallOut = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    this.model.time_start = moment(new Date()).format('YYYY-MM-DD HH-mm');
    this.model.time_end = moment(new Date()).add('1', 'days').format('YYYY-MM-DD HH-mm');
    await this.setUpModal('add');
    this.openModal(this.templateCampaign, config, this.model, {
      modelContent: this.modelContent,
      modelDisplay: this.modelDisplay,
    });
  }

  changeCampaignType($event) {
    this.modelFilter.type = $event.value;
  }

  submitFilter() {
    this.currentPage = 1;
    this.totalItem = this.totalPage = 0;
    if (this.modelFilter.name) {
      this.modelFilter.name = this.modelFilter.name.trim();
    }
    const payload = _.assign({}, this.modelFilter);
    if (payload.from) {
      payload.from = moment(payload.from).format('YYYY-MM-DD HH:mm');
    }
    if (payload.to) {
      payload.to = moment(payload.to).format('YYYY-MM-DD HH:mm');
    }
    this.loadData(payload);
  }

  refresh() {
    this.modelFilter = {
      name: '',
      type: 'all',
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
    };
    this.loadData(this.modelFilter);
  }

  async setPage(page: number) {
    const payload = _.assign({}, this.modelFilter);
    if (payload.from) {
      payload.from = moment(payload.from).format('YYYY-MM-DD HH:mm');
    }
    if (payload.to) {
      payload.to = moment(payload.to).format('YYYY-MM-DD HH:mm');
    }
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(payload);
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData(payload);
        }
      }
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  export() {
    this.campaignService.exportCampaign(this.modelFilter, {});
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    if (this.model.campaign_type === CampaignType.Call) {
      this.model.email_account_id = undefined;
      this.model.template_id = undefined;
    } else {
      this.model.dial_mode = undefined;
      this.model.ivrgateway_id = undefined;
      this.model.queue_id = undefined;
      this.model.callback_url = undefined;
    }
    const payload = {
      name: this.model.name,
      campaign_type: this.model.campaign_type,
      queue_id: this.model.queue_id,
      dial_mode: this.model.dial_mode,
      callback_url: this.model.callback_url,
      email_account_id: this.model.email_account_id,
      template_id: this.model.template_id,
      schedule_id: this.model.schedule_id,
      time_start: moment(this.model.time_start, 'YYYY-MM-DD HH-mm').utc(true).toISOString(),
      time_end: moment(this.model.time_end, 'YYYY-MM-DD HH-mm').utc(true).toISOString(),
    };
    if (payload.time_start && payload.time_end && new Date(payload.time_end) < new Date(payload.time_start)) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Thời gian kết thúc không được sớm hơn thời gian bắt đầu !',
      };
    }
    this.saveCampaign(payload);
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    if (item['campaign_type'] === CampaignType.Call) {
      this.model.email_account_id = undefined;
      this.model.template_id = undefined;
    } else {
      this.model.dial_mode = undefined;
      this.model.ivrgateway_id = undefined;
      this.model.queue_id = undefined;
      this.model.callback_url = undefined;
      this.lstTemplate = [{ id: '', text: 'Mẫu gửi tin' }];
      const type = _.find(this.campaignTypes, { id: item['campaign_type'] });
      if (type) {
        this.allTemplate.forEach(e => {
          if (e.type == type.templateType) {
            this.lstTemplate.push(e);
          }
        });
      }
    }
    if (
      this.model.time_start &&
      this.model.time_end &&
      new Date(this.model.time_end) < new Date(this.model.time_start)
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Thời gian kết thúc không được sớm hơn thời gian bắt đầu !',
      };
    }
    await this.setUpModal('add');
  }

  viewReport(id) {
    this.dataReport.isReport = true;
    this.dataReport.campaignId = id;
  }

  goBack() {
    this.dataReport.isReport = false;
    this.dataReport.campaignId = null;
  }
  onChangeLimit($event) {
    const value = $event.target.value || 10;
    this.changePageLimit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/list/list.component.ts